module.exports = __webpack_public_path__ + "img/tema-3-9.e6ce8d4e.png";